import { KYMW1600Model } from '../kymw1600.model';
import { GetImageInfoModel } from '../vo/get-image-info.model';
import { GetUseImageInfoModel } from '../vo/get-use-image-info.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 使用画像情報取得要求サービス
 *
 * @export UpdateEnabledDeleteService
 * @class UpdateEnabledDeleteService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class UpdateEnabledDeleteService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW1300Model}
   * @memberof UpdateEnabledDeleteService
   */
  private model: KYMW1600Model;

  /**
   * 処理に使用するVO
   *
   * @private
   * @type {Object}
   * @memberof UpdateEnabledDeleteService
   */
  private vo: {
    procMode: string,		// 処理モード:1:使用停止、2:使用停止解除、3:削除
    imageId: string,		// 画像ID
  };

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof UpdateEnabledDeleteService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        ProcMode: this.vo.procMode,
        ImageId: this.vo.imageId
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof UpdateEnabledDeleteService
   */
  execute(model: KYMW1600Model, vo: any): void {
    this.model = model;
    this.vo = vo;
    this.send('KYMW16UpdateEnabledDelete', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof UpdateEnabledDeleteService
   */
  success(data: any): void {
    this.model.updateEnabledDelete(this.vo.procMode);
    this.model.imageInfoDetailChangeFlg = false;
  }
}
